import './faq-section.scss';

class FaqSection {
    constructor (element) {
        this.$faqSection = element;
        this.$faqThemes = this.$faqSection.querySelector('[data-faq-section="themes"]');
        this.$faqQA = this.$faqSection.querySelector('[data-faq-section="qa"]');

        this.activeTheme = this.$faqSection.querySelector('.is--active').getAttribute('data-faq-section-theme-id');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        const $themes = this.$faqThemes.querySelectorAll('[data-faq-section-theme-id]');

        $themes.forEach((theme) => {
            theme.addEventListener('click', () => {
                const id = theme.getAttribute('data-faq-section-theme-id');

                if (id !== this.activeTheme) {
                    this.setTheme(theme);
                    this.setQA(theme, id);
                    this.activeTheme = id;
                }
            });
        });
    }

    setTheme (theme) {
        if (this.activeTheme !== '') {
            const $activeThemes = this.$faqThemes.querySelectorAll('.is--active');

            $activeThemes.forEach((active) => {
                active.classList.remove('is--active');
            });
        }

        theme.classList.add('is--active');
    }

    setQA (theme, id) {
        if (this.activeTheme !== '') {
            const $activeQAs = this.$faqQA.querySelectorAll('[data-faq-section-theme-id].is--active');

            $activeQAs.forEach((QA) => {
                QA.classList.add('is--hidden');
                setTimeout(() => {
                    QA.classList.remove('is--active');
                    QA.classList.remove('is--hidden');
                }, 250);
            });
        }

        const $qa = this.$faqQA.querySelector('[data-faq-section-theme-id="' + id + '"]');
        setTimeout(() => {
            $qa.classList.add('is--active');
        }, 250);
    }
}

export { FaqSection };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $faqSection = $context.querySelector('[data-faq-section="root"]');

        if ($faqSection) {
            const $FaqSection = new FaqSection($faqSection);
            $FaqSection.initialize();
        }
    }
});
